import { array, hash } from '@ember/helper';

import { t } from 'ember-intl';
import { or } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';

export default class RecordDetailFormsLiveEventComponent extends Component {
  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='headline' />
            <fieldset.field @property='text' @type='text-editor' />
            <fieldset.field @property='startDate' @type='date' />
            <fieldset.field @property='startTime' @type='time' />
            <fieldset.field @property='endDate' @type='date' />
            <fieldset.field @property='shopLink' />
            <fieldset.field @property='repertoire' @type='text-editor' />
            <fieldset.field @property='internalRemarks' @type='text-editor' />
            <fieldset.field @property='dgg' @type='checkbox' />
            <fieldset.field @property='secret' @type='checkbox' />
            <fieldset.field @property='tbc' @type='checkbox' />
            <fieldset.field @property='cancelled' @type='checkbox' />
            <fieldset.field @property='ticketAvailability' @type='checkbox' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='artists'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @filters={{hash type=(array 'T_TYPE_LIVE' 'P_TYPE_LIVE')}}
              @property='type'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='ownedByChannel'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='channelsAdditive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExcluded'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExclusive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @filters={{hash partnerType='184'}}
              @property='locationPartners'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            {{#unless (or @model.locationPartners.length @model.isNew)}}
              <InfoBox @type='warning'>
                {{t 'record_detail.forms.live_event.location_hint'}}
                <br />
                <br />
                <fieldset.field @property='manualLocation' @disabled={{true}} />
                <fieldset.field @property='city' @disabled={{true}} />
                <fieldset.field @property='country' @disabled={{true}} />
              </InfoBox>
            {{/unless}}

            <fieldset.field
              @filters={{hash partnerType='182'}}
              @property='presenterPartners'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.fieldset @titleKey='keywords' as |fieldset|>
            <fieldset.field @property='keywords' />
          </form.fieldset>

          <form.sections.seo />

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
